import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent, Button, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'

import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { observer } from 'mobx-react'
import useStore from 'store'
import Export from 'assets/icons/Export.svg'

import {
  DialogHeaderBlue,
  Header,
  StyledClose,
  StyledIconButton,
  StyledIconButtonWhite,
  CategoryListTitleContainer,
  CategoryListTitleSubContainer1,
  CategoryListTitleSubContainer2,
  HeaderTitle1,
  HeaderTitle2,
  ImageHeader,
  NewCategoryBody,
  NewCategoryContainerColumn,
  NewCategoryContainerActions,
} from './CategoryModal.styles'

import FileIcon from 'assets/icons/ims/File.svg'
import User4Icon from 'assets/icons/ims/User4.svg'
import DocIcon from 'assets/icons/protocols/icon12.svg'
import ShareIcon from 'assets/icons/protocols/icon13.svg'
import PrintIcon from 'assets/icons/protocols/icon14.svg'
import PeopleIcon from 'assets/icons/protocols/icon15.svg'
import PeopleIcon2 from 'assets/icons/protocols/icon16.svg'
import MessageIcon from 'assets/icons/protocols/icon17.svg'
import CheckIcon from 'assets/icons/protocols/icon18.svg'
import DocIcon2 from 'assets/icons/protocols/icon19.svg'
import FileIcon3 from 'assets/icons/protocols/icon21.svg'
import DownloadIcon from 'assets/icons/protocols/icon22.svg'
import SecondaryFileIcon from 'assets/icons/protocols/icon23.svg'


const HeaderDialogButton = styled(Button)`
  display: flex;
  height: 39.986px;
  margin-right: 10px;
  padding-left: 15.994px;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.20);
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #101828;
  font-family: Rubik;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  direction: rtl;
  width: 100%;
`
const SectionDot = styled.span<{ color?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${p => p.color ?? '#3B82F6'};
  flex-shrink: 0;
`

const SectionBody = styled.div`
  color: #4A5565;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  direction: rtl;
  text-align: right;
  width: 100%;
  white-space: pre-line;
`

const CategoryBadge = styled.div<{ color: string; bg: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: ${p => p.bg};
  color: ${p => p.color};
  font-family: Rubik;
  font-size: 13px;
  font-weight: 500;
`

const ParticipantRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  direction: rtl;
  width: 100%;
  padding: 6px 0;
  border-bottom: 0.5px solid #F1F5F9;
  &:last-child { border-bottom: none; }
`

const ParticipantName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
`

const ParticipantRole = styled.div`
  color: #4A5565;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`

const FileCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #F8FAFC;
  direction: rtl;
  width: 100%;
  box-sizing: border-box;
`

const FileInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const FileName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`

const FileSize = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
`

const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #EFF6FF;
  color: #1C398E;
  text-decoration: none;
  flex-shrink: 0;
  &:hover { background: #DBEAFE; }
`
const ImageHeaderBlue = styled(Image)`
 padding-left: 5px;
`
const FileIconImg = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`
const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #F1F5F9;
`
const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  width: 100%;
`
const MetaRow = styled.div`
  display: flex;
  gap: 20px;
  direction: rtl;
  color: #64748B;
  font-family: Rubik;
  font-size: 13px;
`
const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`
const ImportExportImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const CategoryViewContainer = styled.div`
  border-radius: 8px;
  padding: 50px;
  border: 0.909px solid #E5E7EB;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const CloseButton = styled(Button)`
  border-radius: 8px;
  background: #E5E7EB;
  display: flex;
  padding: 8px 24px 8px 24px;
  justify-content: center;
  align-items: center;
  color: #364153;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const Container1 = styled.div`
  display: flex;
  width: 100%;
  height: 65px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.909px solid #E5E7EB;
`
const TextStyle1 = styled.div`
  color: #6A7282;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const ButtonStyled1 = styled.div`
  display: flex;
  padding: 10px 18px 10px 18px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1.818px solid #3B82F6;
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; 
`
const TitleStyled1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 7.585px;
  align-self: stretch;
  color: #1E2939;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

`
const ContainerStyled1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;  
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const ContainerVerticalStyled1  = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;  
  flex-direction: column;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`

const ContainerContent1 = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  margin-top: 20px;
`
const UserCard = styled.div`
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  height: 38px;
  align-items: center;
  gap: 7.997px;
  border-radius: 8px;
  border: 1px solid #BEDBFF;
  background: #EFF6FF;
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const ItemCard = styled.div`
  display: flex;
  height: 21.989px;
  padding-right: 0;
  align-items: flex-start;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const ItemNumber = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #155DFC;
  color: #FFF;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
const Container1Text = styled.div`
  display: flex;
  padding: 26px 24px 24px 36px;
  justify-content: flex-start;
  text-align: right;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
`
const MainFileContainer = styled.div`
  display: flex;
  width: 100%;
  height: 91.619px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1.818px solid #51A2FF;
  background: linear-gradient(90deg, #EFF6FF 0%, #DBEAFE 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const DownloadMainFileButton = styled(Button)`
  display: flex;
  padding: 12px 20px 12px 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 7.594px;
  border-radius: 8px;
  background: #155DFC;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
`
const IconMainFileContainer = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  margin-left: 10px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: #155DFC;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
`
const MainFileDetailsContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  wisth: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.992px;
  flex-shrink: 0;
`
const MainFileName = styled.div`
color: #101828;
font-family: Rubik;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`
const MainFileSize = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const MainFileBadge = styled.div`
  display: flex;
  padding: 2px 8px 2px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #155DFC;
  color: #FFF;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`
const MainFileDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const TitleStyled2 = styled.div`
  width: 100%;
  display: flex;
  height: 20px;
  padding: 0 8px 0 8px;
  justify-content: flex-start;
  align-items: center;
  color: #4A5565;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const SecondaryFileContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #F9FAFB;
`
const DownloadSecondaryFileButton = styled(Button)`
  display: flex;
  padding: 8px 16px 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 7.963px;
  border-radius: 8px;
  background: #4A5565;
  color: #FFF;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
const IconSecondaryFileContainer = styled.div`
  display: flex;
  margin-left: 10px;
  width: 36px;
  height: 36px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: #D1D5DC;
`

const formatFileSize = (bytes: number): string => {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}


const ProtocolViewModal = ({ open, protocolId, onClose }: { open: boolean; protocolId: number | null; onClose: () => void }) => {
  const { protocolsStore } = useStore()
  const data = protocolsStore.protocolView
  const loading = protocolsStore.loadingProtocolView

  const dateStr = data?.protocolDate ? new Date(data.protocolDate).toLocaleDateString('he-IL') : ''
  const modifiedStr = data?.modifiedDate ? new Date(data.modifiedDate).toLocaleDateString('he-IL') : ''

  return (
    <Dialog style={{ zIndex: 1200 }} open={open} fullWidth maxWidth="md" scroll="body">
      <DialogHeaderBlue>
        <Header style={{ background: 'linear-gradient(90deg, #155DFC 0%, #1447E6 100%)'  }}>
          <CategoryListTitleContainer>
            <CategoryListTitleSubContainer2>
              <ImageHeader src={DocIcon} />
            </CategoryListTitleSubContainer2>
            <CategoryListTitleSubContainer1>
              <HeaderTitle1 style={{ color: 'white' }}>
                {data?.title || 'צפייה בפרוטוקול'}
              </HeaderTitle1>
              <HeaderTitle2>
                <MetaRow style={{ color: '#DBEAFE' }}>
                  {dateStr && <MetaItem>תאריך פרוטוקול: {dateStr}</MetaItem>}
                  {modifiedStr && <MetaItem>עודכן: {modifiedStr}</MetaItem>}
                  {data?.creatorName && <MetaItem>כותב: {data.creatorName}</MetaItem>}
                </MetaRow>
              </HeaderTitle2>
            </CategoryListTitleSubContainer1>
          </CategoryListTitleContainer>
          {/*<>
          <HeaderDialogButton><ImageHeaderBlue src={PrintIcon} /> הדפס פרוטוקול</HeaderDialogButton>
          <HeaderDialogButton><ImageHeaderBlue src={ShareIcon} /> שתף פרוטוקול</HeaderDialogButton>
          </>*/}
          <StyledIconButtonWhite onClick={onClose}><StyledClose /></StyledIconButtonWhite>
        </Header>
      </DialogHeaderBlue>

      <DialogContent>
        <CategoryViewContainer>
          {loading && <SpinnerWrap><Spinner /></SpinnerWrap>}

          {!loading && data && (
            <>
              <Container1>
                <ButtonStyled1>סיכומי אסיפות</ButtonStyled1>
                <TextStyle1>עדכון אחרון: {modifiedStr}</TextStyle1>
              </Container1>

              <ContainerContent1>
                <TitleStyled1><Image src={PeopleIcon}/> משתתפים {`(${data.participants.length})`}</TitleStyled1>
                <ContainerStyled1>
                  {data.participants.map((p, i) => (
                    <UserCard>
                      <Image src={PeopleIcon2}/>  
                      <ParticipantName>{p.participantName}</ParticipantName>
                      {p.participantRole && <ParticipantRole> • {p.participantRole}</ParticipantRole>}
                    </UserCard>
                  ))}
                </ContainerStyled1>
              </ContainerContent1>

              {data.topics && (
               <ContainerContent1>
                <TitleStyled1><Image src={MessageIcon}/> נושאי דיון</TitleStyled1>
                <ContainerVerticalStyled1>
                  {data.topics.split(';').map((t, i) => (
                    <ItemCard><ItemNumber>{i+1}</ItemNumber> {t}</ItemCard>  
                  ))}   
                </ContainerVerticalStyled1>
              </ContainerContent1>
              )}

              {data.decisions &&
              <ContainerContent1>
                <TitleStyled1><Image src={CheckIcon}/> החלטות</TitleStyled1>
                <ContainerVerticalStyled1>
                  {data.decisions.split(';').map(d => (
                    <ItemCard><Image src={CheckIcon}/>{d}</ItemCard>  
                  ))}    
                </ContainerVerticalStyled1>
              </ContainerContent1>
              }

              {data.description && 
              <ContainerContent1>
                <TitleStyled1><Image src={DocIcon2}/> קבצים מצורפים</TitleStyled1>
                <Container1Text>
                  {data.description}
                </Container1Text>
              </ContainerContent1>
              }

              {(data.mainFile || data.attachments?.length > 0) &&
              <ContainerContent1>
                <TitleStyled1><Image src={FileIcon3}/> נושאי דיון</TitleStyled1>
                <ContainerVerticalStyled1>

                {data.mainFile && 
                  <MainFileContainer>
                    <IconMainFileContainer>
                      <ImageHeaderBlue src={DocIcon} />
                    </IconMainFileContainer>

                    <MainFileDetailsContainer>
                      <MainFileDetails>
                        <MainFileName>{data.mainFile.fileName}</MainFileName>
                        <MainFileBadge>פרוטוקול ראשי</MainFileBadge>
                      </MainFileDetails>
                      <MainFileSize>{formatFileSize(data.mainFile.fileSize)}</MainFileSize>
                    </MainFileDetailsContainer>

                    <DownloadMainFileButton  onClick={() => protocolsStore.downloadProtocolFile(protocolId, data.mainFile.id, data.mainFile.fileName)}>
                      <ImageHeaderBlue src={DownloadIcon} /> הורד פרוטוקול
                    </DownloadMainFileButton>
                  </MainFileContainer>
                }

                {data.attachments?.length > 0 && <>
                <TitleStyled2>קבצים נוספים ({data.attachments.length})</TitleStyled2>
                {data.attachments?.map((file, i) => (
                  <SecondaryFileContainer>
                    <IconSecondaryFileContainer>
                      <ImageHeaderBlue src={SecondaryFileIcon} />
                    </IconSecondaryFileContainer>

                    <MainFileDetailsContainer>
                      <MainFileDetails>
                        <MainFileName>{file.fileName}</MainFileName>
                      </MainFileDetails>
                      <MainFileSize>{formatFileSize(file.fileSize)}</MainFileSize>
                    </MainFileDetailsContainer>

                    <DownloadSecondaryFileButton  onClick={() => protocolsStore.downloadProtocolFile(protocolId, file.id, file.fileName)}>
                      <ImageHeaderBlue src={DownloadIcon} /> הורדה
                    </DownloadSecondaryFileButton>
                  </SecondaryFileContainer>
                ))}
                </>
                }
                </ContainerVerticalStyled1>
              </ContainerContent1>
            }
           
            </>
          )}
        </CategoryViewContainer>
        <NewCategoryContainerActions style={{ paddingRight: 0 }}>
          <CloseButton onClick={onClose}>סגור</CloseButton>
        </NewCategoryContainerActions>
      </DialogContent>
    </Dialog>
  )
}

export default observer(ProtocolViewModal)
